import { createContext, type ReactElement } from 'react';

import { DataProvider } from '../DataProvider';
import { transformGlobal } from './transformGlobal';
import type { GlobalContextValue } from './types';

export const GlobalContext = createContext<GlobalContextValue>({} as GlobalContextValue);

export function GlobalDataProvider({
  children,
  url = 'data/global.json',
  load = true,
}: {
  readonly children: ReactElement;
  readonly url?: string;
  readonly load: boolean;
}): ReactElement {
  return (
    <DataProvider url={url} DataContext={GlobalContext} transformer={transformGlobal} load={load}>
      {children}
    </DataProvider>
  );
}
